export class AdvancedFiltersBuilder {
  public readonly connective: string = '';
  public readonly advanced_filters: AdvancedFilters[] = [];
}

export class AdvancedFilters {
  public readonly attribute!: string;
  public readonly relation!: string;
  public readonly value!: unknown;
}
